/* eslint-disable import/prefer-default-export */
export const capitales = [
  {
    country: 'Albania',
    name: 'Tirana',
    latitude: 41.3275,
    longitude: 19.8189,
  },
  {
    country: 'Andorra',
    name: 'Andorre-la-Vieille',
    latitude: 42.5045,
    longitude: 1.4941,
  },
  {
    country: 'Austria',
    name: 'Vienna',
    latitude: 48.2092,
    longitude: 16.3728,
  },

  {
    country: 'Belarus',
    name: 'Minsk',
    latitude: 54,
    longitude: 28,
  },
  {
    country: 'Herzegovina',
    name: 'Sarajevo',
    latitude: 43.8486,
    longitude: 18.3564,
  },
  {
    country: 'Bulgaria',
    name: 'Sofia',
    latitude: 42.6975,
    longitude: 23.3242,
  },
  {
    country: 'Cyprus',
    name: 'Nicosia',
    latitude: 35.1667,
    longitude: 33.3667,
  },
  {
    country: 'Croatia',
    name: 'Zagreb',
    latitude: 45.8131,
    longitude: 15.9775,
  },
  {
    country: 'Denmark',
    name: 'Copenhagen',
    latitude: 55.6759,
    longitude: 12.5655,
  },
  {
    country: 'Estonia',
    name: 'Tallinn',
    latitude: 59.437,
    longitude: 24.7535,
  },
  {
    country: 'Finland',
    name: 'Helsinki',
    latitude: 60.1695,
    longitude: 24.9355,
  },
  {
    country: 'Greece',
    name: 'Athens',
    latitude: 37.9795,
    longitude: 23.7162,
  },
  {
    country: 'Hungary',
    name: 'Budapest',
    latitude: 47.498,
    longitude: 19.0399,
  },
  {
    country: 'Ireland',
    name: 'Dublin',
    latitude: 53.344,
    longitude: -6.2672,
  },
  {
    country: 'Iceland',
    name: 'Reykjavik',
    latitude: 64.35,
    longitude: -22.4574,
  },
  {
    country: 'Italy',
    name: 'Rome',
    latitude: 41.8947,
    longitude: 12.4839,
  },
  {
    country: 'Kosovo',
    name: 'Pristina',
    latitude: 42.6727,
    longitude: 21.1669,
  },
  {
    country: 'Latvia',
    name: 'Riga',
    latitude: 57,
    longitude: 24.0833,
  },
  {
    country: 'Liechtenstein',
    name: 'Vaduz',
    latitude: 47.1415,
    longitude: 9.5215,
  },
  {
    country: 'Lithuania',
    name: 'Vilnius',
    latitude: 54.6892,
    longitude: 25.2798,
  },
  {
    country: 'Luxembourg',
    name: 'Luxembourg',
    latitude: 49.6117,
    longitude: 6.13,
  },
  {
    country: 'Northern Macedonia',
    name: 'Skopje',
    latitude: 42,
    longitude: 21.4333,
  },
  {
    country: 'Malta',
    name: 'La Valette',
    latitude: 35.8997,
    longitude: 14.5147,
  },
  {
    country: 'Moldova',
    name: 'Chisinau',
    latitude: 47.005,
    longitude: 28.8575,
  },
  {
    country: 'Monaco',
    name: 'Monaco',
    latitude: 43.7314,
    longitude: 7.419,
  },
  {
    country: 'Montenegro',
    name: 'Podgorica',
    latitude: 42.4411,
    longitude: 19.2636,
  },
  {
    country: 'Norway',
    name: 'Oslo',
    latitude: 59.9127,
    longitude: 10.7461,
  },
  {
    country: 'Poland',
    name: 'Warsaw',
    latitude: 52.2298,
    longitude: 21.0118,
  },

  {
    country: 'Czech Republic',
    name: 'Prague',
    latitude: 50.088,
    longitude: 14.4208,
  },
  {
    country: 'Russia',
    name: 'Moscow',
    latitude: 55.7522,
    longitude: 37.6156,
  },
  {
    country: 'Serbia',
    name: 'Belgrade',
    latitude: 44.804,
    longitude: 20.4651,
  },
  {
    country: 'Slovakia',
    name: 'Bratislava',
    latitude: 48.1482,
    longitude: 17.1067,
  },
  {
    country: 'Slovenia',
    name: 'Ljubljana',
    latitude: 46.0511,
    longitude: 14.5051,
  },
  {
    country: 'Switzerland',
    name: 'Bern',
    latitude: 46.9481,
    longitude: 7.4474,
  },
  {
    country: 'Sweden',
    name: 'Stockholm',
    latitude: 59.3326,
    longitude: 18.0649,
  },
  {
    country: 'Ukraine',
    name: 'Kiev',
    latitude: 50.4333,
    longitude: 30.5167,
  },
  {
    country: 'Portugal',
    name: 'Lisbon',
    latitude: 38.7222,
    longitude: -9.1393,
  },
  {
    country: 'France',
    name: 'Paris',
    latitude: 48.8566,
    longitude: 2.3522,
  },
  {
    country: 'Belgium',
    name: 'Brussels',
    latitude: 50.8503,
    longitude: 4.3517,
  },
  {
    country: 'Spain',
    name: 'Madrid',
    latitude: 40.4168,
    longitude: -3.7037,
  },
  {
    country: 'Germany',
    name: 'Berlin',
    latitude: 52.52,
    longitude: 13.405,
  },
  {
    country: 'England',
    name: 'London',
    latitude: 51.5074,
    longitude: -0.1278,
  },
];
